// CGE ONLY!

export interface Language {
  code: 'en' | 'fr';
  label: string;
}

export const ENGLISH: Language = {
  code: 'en',
  label: 'more.ENGLISH'
} as const;

export const FRENCH: Language = {
  code: 'fr',
  label: 'more.FRENCH'
} as const;

export const AVAILABLE_LANGUAGES = [ENGLISH, FRENCH] as const;
